export default __webpack_public_path__ + "static/media/oni_dark.6086bd64.svg";